import React from 'react';
import SkillAnalyzerCard from './SkillAnalyzerCard';

/**
 * SkillAnalyzerPool
 * Panel showing all selected skills with scenario pickers.
 */

const SkillAnalyzerPool = ({ selectedSkills, onRemove, onScenarioChange }) => {
    if (selectedSkills.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-10 gap-3">
                {/* Empty state icon */}
                <div className="w-12 h-12 rounded-2xl bg-slate-800 border border-slate-700
                    flex items-center justify-center">
                    <svg className="w-6 h-6 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                            d="M12 4v16m8-8H4" />
                    </svg>
                </div>
                <p className="text-slate-600 text-sm text-center leading-relaxed">
                    Add skills from the search<br />to start analyzing
                </p>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2">
            {/* Header counter */}
            <div className="flex items-center justify-between px-1 mb-1">
                <span className="text-xs font-bold text-slate-500 uppercase tracking-widest">
                    Selected Skills
                </span>
                <span className="text-xs font-mono text-violet-400">
                    {selectedSkills.length}
                </span>
            </div>

            {/* Cards */}
            <div className="flex flex-col gap-2">
                {selectedSkills.map(skill => (
                    <SkillAnalyzerCard
                        key={skill.Id_skill}
                        skill={skill}
                        onRemove={onRemove}
                        onScenarioChange={onScenarioChange}
                    />
                ))}
            </div>

            {/* Clear all */}
            {selectedSkills.length > 1 && (
                <button
                    onClick={() => selectedSkills.forEach(s => onRemove(s.Id_skill))}
                    className="mt-2 w-full text-xs text-slate-500 hover:text-rose-400
                        py-2 rounded-lg border border-transparent
                        hover:border-rose-900/40 hover:bg-rose-900/10
                        transition-all"
                >
                    Clear all
                </button>
            )}
        </div>
    );
};

export default SkillAnalyzerPool;
